module.exports = __webpack_public_path__ + "media/download.d90509bd.svg";